import KeyMirror from 'keymirror'

export const POST_FITOUT_STATUS = KeyMirror({
  UNDER_REVIEW: null,
  COMPLETED: null,
})

export const PF_HISTORY_TYPE = KeyMirror({
  SUBMISSION: null,
  GUIDELINE: null,
})

export const PF_HISTORY_ACTION_TYPE = KeyMirror({
  SEND: null,
  RESEND: null,
  NEXT_REVIEWER: null,
  RECEIVERS: null,
  CHECKED: null,
  UPDATE: null,
  ADD: null,
  DELETE: null,
})
